/** Single source of truth for the CLI version — read from package.json at runtime. */
import { readFileSync } from 'node:fs'
import { fileURLToPath } from 'node:url'

export const PACKAGE_NAME = '@verentis/cli'

let cached: string | undefined

/**
 * The installed CLI version, read from the package's own package.json.
 *
 * The release pipeline bumps package.json (`npm version`) but not any source constant, so reading it
 * at runtime keeps `verentis --version`, the update notice and `verentis update` all in agreement.
 */
export function getCliVersion(): string {
  if (cached) return cached
  cached = readVersion() ?? '0.0.0'
  return cached
}

function readVersion(): string | undefined {
  // The bundled entry lives at dist/index.js and the source at src/*, so package.json is one level up
  // in both layouts. Fall back one more level for safety, guarding against grabbing a foreign manifest.
  const candidates = ['../package.json', '../../package.json']
  for (const relative of candidates) {
    try {
      const raw = readFileSync(fileURLToPath(new URL(relative, import.meta.url)), 'utf8')
      const pkg = JSON.parse(raw) as { name?: string; version?: string }
      if (pkg.version && (relative === '../package.json' || pkg.name === PACKAGE_NAME)) return pkg.version
    } catch {
      // try the next candidate
    }
  }
  return undefined
}
